<template>
    <div class="px-5 pt-5">
        <div class="max-w-2xl mx-auto bg-gradient-to-br from-orange-50 to-red-50 border-2 border-orange-300 rounded-xl shadow-lg p-6 animate-fade-in">
            <div class="flex items-start flex-col gap-4">
                <!-- Ícone e Título -->
                <div class="flex flex-row gap-3 items-start w-full">
                    <div class="flex-shrink-0">
                        <div class="w-14 h-14 bg-orange-100 rounded-full flex items-center justify-center">
                            <svg
                                class="w-8 h-8 text-orange-600"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                />
                            </svg>
                        </div>
                    </div>
                    
                    <div class="flex-1">
                        <h2 class="text-orange-900 text-2xl font-grotesk75 mb-2">
                            Checkout Desativado para Pagamentos
                        </h2>
                        <p class="text-orange-800 text-base font-grotesk65 mb-4">
                            Este checkout está temporariamente desativado e não está aceitando pagamentos no momento.
                        </p>
                    </div>
                </div>

                <!-- Motivo do bloqueio -->
                <div v-if="message" class="bg-white/80 rounded-lg p-5 border border-orange-200 w-full">
                    <p class="text-orange-900 font-grotesk75 text-sm mb-3 font-semibold">
                        Motivo:
                    </p>
                    <div class="flex items-start gap-3">
                        <span class="text-orange-500 mt-1 flex-shrink-0">•</span>
                        <p class="text-orange-800 text-base font-grotesk65 leading-relaxed">
                            {{ message }}
                        </p>
                    </div>
                </div>

                <!-- Informações adicionais -->
                <div class="bg-blue-50 rounded-lg p-4 border border-blue-200 w-full">
                    <div class="flex items-start gap-3">
                        <svg
                            class="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                        </svg>
                        <p class="text-blue-800 text-sm font-grotesk65">
                            Se você acredita que isso é um erro, entre em contato com o suporte da loja ou tente novamente mais tarde.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
defineProps({
    message: {
        type: String,
        default: null
    }
});
</script>

<style scoped>
@keyframes fade-in {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.animate-fade-in {
    animation: fade-in 0.3s ease-out;
}
</style>
